import { jsx, jsxs } from "react/jsx-runtime";
import { Error } from "@wix/wix-ui-icons-common/on-stage";
import { SectionNotification, SectionNotificationType } from "@wix/wix-ui-tpa/cssVars";
import { st, classes } from "./notification.st.css";
const Notification = ({
  message,
  isError
}) => {
  return /* @__PURE__ */ jsx("div", { className: st(classes.root, { error: isError }), children: /* @__PURE__ */ jsxs(
    SectionNotification,
    {
      className: classes.sectionNotification,
      type: SectionNotificationType.wired,
      children: [
        isError && /* @__PURE__ */ jsx(SectionNotification.Icon, { icon: /* @__PURE__ */ jsx(Error, {}) }),
        /* @__PURE__ */ jsx(SectionNotification.Text, { children: message })
      ]
    }
  ) });
};
export {
  Notification
};
//# sourceMappingURL=index.js.map
